import React, { useState, useEffect, useContext } from 'react';

import { useNavigate, Link, Navigate, useParams } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../../components/imports'

import { WEBROOT, APP_NAME, PHOTOS_ROOT } from '../../constants/general'

import { Text } from '../../constants/Text'

import { Context } from '../../class/Context'

import Func from '../../class/Func'

import Annonces from '../../class/Annonces';

function MasquerAnnonce() {

    const { id } = useParams()

    const navigate = useNavigate()

    const context = useContext(Context)

    const [loading, setLoading] = useState(true)

    const [error, setError] = useState('')

    const [success, setSuccess] = useState('')

    const [annonce, setAnnonce] = useState(false)

    const getAnnonce = async () => {

        let results = await Annonces.annoncesById(id)

        if (results.success) {

            if (results.data.idU != localStorage.idU || (results.data.stt != '0' && results.data.stt != '5')) navigate('/404')

            setAnnonce(results.data)

        } else {

            navigate('/404')

        }

        setLoading(false)

    }


    const action = async (id) => {

        let results = await Annonces.masquer(id)

        if (results.success) {

            setSuccess(results.message)

        } else {

            setError(results.message)

        }

    }

    useEffect(() => {

        Func.session(context, navigate)

        document.title = "Masquer une annonce - " + APP_NAME

        window.scrollTo(0, 0)

        getAnnonce()

    }, [])


    return (
        <div className="">

            <Header />

            <HeaderBox />

            <div className='content pos-r'>

                <div className="shape1 mt50">
                    <svg height="535" viewBox="0 0 487 635" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.90">
                            <path d="M441.275 320.547C438.29 322.329 433.455 325.32 433.198 325.37C383.565 340.369 358.204 294.818 357.951 294.355C335.233 261.905 335.728 231.377 335.497 230.247C327.655 192.409 311.381 178.845 311.16 178.708C286.493 161.276 263.971 176.393 262.941 177.288C241.412 196.778 225.032 204.045 224.477 204.376C185.437 227.691 160.854 224.537 121.57 217.566C88.7222 214.57 53.6595 236.327 53.2386 236.562C-5.71939 267.97 -14.999 336.613 -15.0988 337.314C-25.9555 412.227 -73.8629 470.232 -74.3109 470.866C-93.5106 498.137 -101.677 499.69 -109.721 505.706C-126.589 516.96 -127.486 527.216 -127.5 527.746L-134.593 527.588C-134.581 526.917 -134.148 512.746 -113.683 497.469L-113.406 497.287L-107.868 493.728C-107.716 493.659 -96.7686 490.015 -80.1971 466.939C-79.9042 466.457 -39.1881 401.73 -26.5254 336.807C-25.9664 333.84 -20.6694 263.182 54.7582 224.544C56.5419 223.627 90.7968 202.841 129.806 209.333C130.739 209.499 183.179 217.545 219.861 195.638C220.049 195.53 234.88 190.146 255.843 171.17C256.192 170.863 285.836 145.666 317.048 168.351C317.859 168.844 339.556 183.491 345.869 230.905C345.876 230.972 349.706 255.753 371.449 286.848C372.583 288.892 386.655 327.541 430.968 314.166C431.789 313.973 443.437 310.731 445.923 288.475C446.933 280.288 450.343 272.58 455.728 266.31L464.696 270.011C457.718 277.898 457.128 290.852 457.125 290.98C455.101 309.223 446.905 317.184 441.275 320.547Z" fill="#879F85" />
                            <path d="M454.083 268.415C454.083 268.415 457.156 263.509 461.37 264.032C461.37 264.032 464.891 265.276 464.871 269.831L454.083 268.415Z" fill="#879F85" />
                            <path d="M227.138 199.705C226.486 200.12 225.783 200.45 225.046 200.686L223.689 196.186C223.794 196.139 235.668 191.658 252.495 152.244C252.695 151.68 258.765 135.299 279.217 124.289L281.468 128.425C262.72 138.483 256.955 153.799 256.906 153.949C242.61 187.43 231.634 197.02 227.138 199.705Z" fill="#879F85" />
                            <path d="M278.752 147.706C280.715 146.523 281.348 143.972 280.164 142.007C278.98 140.043 276.429 139.409 274.466 140.592C272.502 141.774 271.87 144.326 273.054 146.29C274.238 148.255 276.789 148.888 278.752 147.706Z" fill="#879F85" />
                            <path d="M286.979 131.069C290.326 129.051 291.211 124.378 288.956 120.631C286.702 116.884 282.161 115.482 278.814 117.5C275.467 119.517 274.582 124.19 276.837 127.938C279.092 131.685 283.633 133.087 286.979 131.069Z" fill="#879F85" />
                            <path d="M294.232 143.392C296.195 142.209 296.827 139.658 295.644 137.693C294.46 135.729 291.909 135.095 289.946 136.278C287.982 137.46 287.35 140.012 288.534 141.976C289.717 143.941 292.268 144.574 294.232 143.392Z" fill="#879F85" />
                            <path d="M269.297 124.91C271.905 123.34 272.745 119.951 271.173 117.341C269.6 114.732 266.212 113.89 263.604 115.461C260.996 117.032 260.156 120.421 261.728 123.03C263.301 125.64 266.689 126.481 269.297 124.91Z" fill="#879F85" />
                            <path d="M271.3 106.605C273.023 104.617 276.286 104.635 278.59 106.644C280.893 108.653 281.362 111.893 279.639 113.881C277.915 115.869 274.652 115.852 272.349 113.843C270.045 111.833 269.576 108.592 271.3 106.605Z" fill="#879F85" />
                            <path d="M293.718 115.051C295.959 113.701 296.681 110.788 295.329 108.545C293.978 106.302 291.065 105.578 288.824 106.928C286.582 108.278 285.86 111.191 287.212 113.434C288.563 115.678 291.476 116.401 293.718 115.051Z" fill="#879F85" />
                            <path d="M303.021 130.532C305.263 129.181 305.985 126.268 304.633 124.025C303.282 121.782 300.369 121.058 298.127 122.409C295.886 123.759 295.164 126.672 296.516 128.915C297.867 131.158 300.78 131.882 303.021 130.532Z" fill="#879F85" />
                            <path d="M340.326 227.325C340.326 227.325 328.841 218.934 321.919 220.991C321.919 220.991 316.88 221.913 324.034 232.61C324.034 232.61 335.215 245.904 341.556 245.702L340.326 227.325Z" fill="#879F85" />
                            <path d="M348.347 265.627C346.482 266.296 336.085 255.733 332.963 262.63C332.963 262.63 332.838 274.536 352.55 277.202L348.347 265.627Z" fill="#879F85" />
                            <path d="M369.567 301.529C367.499 301.867 354.467 292.289 350.554 303.138C350.554 303.138 351.175 313.98 373.984 308.866L369.567 301.529Z" fill="#879F85" />
                            <path d="M416.871 323.472C416.535 323.673 397.067 336.215 407.086 340.193C407.086 340.193 417.175 342.774 425.643 323.668L416.871 323.472Z" fill="#879F85" />
                            <path d="M441.388 315.834C441.388 315.834 449.52 330.082 460.772 317.847C460.772 317.847 462.29 310.569 445.871 308.189L441.388 315.834Z" fill="#879F85" />
                            <path d="M424.173 321.011C424.173 321.011 407.012 315.892 415.738 306.999C415.738 306.999 423.982 302.03 435.663 316.811L424.173 321.011Z" fill="#879F85" />
                            <path d="M344.797 252.793C343.449 252.697 346.596 239.587 353.454 235.757C353.454 235.757 359.843 233.422 358.143 243.541C358.143 243.541 356.476 248.179 349.168 263.191L344.797 252.793Z" fill="#879F85" />
                            <path d="M381.109 312.507C381.109 312.507 379.452 297.711 378.659 292.071C378.659 292.071 379.385 277.628 372.946 268.773C372.946 268.773 366.564 268.073 366.334 260.628C366.334 260.628 367.081 253.805 374.546 255.669C374.546 255.669 381.495 259.67 378.822 267.346C378.822 267.346 385.838 281.569 384.885 291.575C384.885 291.575 389.778 279.239 388.119 270.837C388.119 270.837 382.775 264.357 388.435 260.94C388.435 260.94 394.846 258.281 396.589 265.723C396.589 265.723 398.727 269.794 392.582 272.646C392.582 272.646 396.235 272.612 388.127 300.717C388.127 300.717 391.078 294.84 402.662 288.453C402.662 288.453 398.349 282.26 405.977 277.351C405.977 277.351 413.039 275.512 413.494 282.827C413.094 284.687 412.278 286.43 411.106 287.926C409.935 289.421 408.439 290.629 406.733 291.457C406.733 291.457 396.812 296.844 395.042 302.462C395.042 302.462 391.061 311.237 397.51 317.81L381.109 312.507Z" fill="#879F85" />
                            <path d="M14.562 264.906C14.562 264.906 20.5079 275.411 27.4071 277.934C27.4071 277.934 33.2287 278.687 32.4617 274.914C32.4617 274.914 33.0858 273.941 30.0444 270.922C30.0444 270.922 22.317 268.871 18.203 262.731C18.203 262.731 10.7687 247.1 15.778 239.579C15.778 239.579 23.0566 229.793 30.1545 230.991C30.1545 230.991 36.1112 232.568 31.4073 240.211L47.4282 228.742C47.4282 228.742 40.5354 228.58 44.1045 220.929C44.1045 220.929 49.714 209.645 62.746 209.107C62.746 209.107 75.4235 209.988 68.7883 219.087L84.7868 213.42C84.7868 213.42 78.4149 209.408 81.2643 204.085C81.2643 204.085 84.6905 198.714 96.1099 194.01C96.1099 194.01 106.861 191.208 113.081 200.48C113.081 200.48 117.05 205.032 109.764 208.036L129.208 209.573L126.192 202.579C126.192 202.579 136.858 194.129 138.096 186.141C138.096 186.141 146.486 201.5 163.502 198.518C163.502 198.518 183.189 193.933 181.554 177.697C181.554 177.697 171.552 187.749 151.44 179.606C151.44 179.606 149.821 177.929 146.062 173.229C146.062 173.229 145.579 169.288 149.952 171.81C149.952 171.81 162.947 180.057 171.736 177.522C171.736 177.522 189.182 173.745 183.207 151.342C183.207 151.342 175.55 165.276 165.191 162.704C165.191 162.704 160.46 163.417 152.864 157.383C152.864 157.383 152.947 154.014 159.02 155.517C159.02 155.517 174.695 160.346 180.251 146.46C180.251 146.46 184.387 138.251 181.832 132.529C181.832 132.529 172.083 141.996 162.862 141.304C162.862 141.304 157.251 139.06 161.711 136.396C161.711 136.396 176.752 137.675 178.878 127.65C178.878 127.65 180.297 119.965 176.47 114.647C176.47 114.647 175.3 123.746 162.851 125.746C162.851 125.746 157.318 126.637 159.808 121.221C159.808 121.221 174.016 118.472 172.719 108.379L172.267 104.699C172.267 104.699 168.747 113.424 157.552 113.489C157.552 113.489 155.287 112.752 159.657 110.443C159.657 110.443 172.682 106.887 168.111 94.8207L166.168 88.6048L154.45 93.3223C154.45 93.3223 145.39 95.4097 150.996 110.183C150.996 110.183 141.719 113.914 143.387 98.115C143.387 98.115 131.88 104.687 146.766 117.241C146.766 117.241 150.637 120.619 144.623 121.216C144.623 121.216 133.382 120.705 131.789 103.535C131.789 103.535 116.073 122.513 138.695 131.484C138.695 131.484 143.539 135.476 135.685 136.542C135.685 136.542 118.446 129.628 119.003 114.499C119.003 114.499 100.363 136.865 128.751 144.645C128.751 144.645 136.059 145.684 130.22 150.077C130.22 150.077 114.082 154.012 106.066 128.737C106.066 128.737 91.7473 150.715 116.362 162.287C116.362 162.287 123.641 164.281 128.547 164.368C128.547 164.368 134.566 168.789 128.151 170.727C128.151 170.727 114.729 175.64 99.88 156.123L98.5676 155.458C98.5676 155.458 90.5981 169.514 110.281 184.328C110.281 184.328 117.832 189.786 130.187 183.613C130.187 183.613 131.045 190.048 120.255 196.794C120.255 196.794 106.299 178.252 87.0805 189.129C81.4495 192.808 76.7387 197.716 73.3066 203.48C73.3066 203.48 43.4791 192.209 35.3206 223.978C35.3206 223.978 -1.19952 218.131 9.85459 259.024L14.562 264.906Z" fill="#879F85" />
                            <path d="M32.985 245.934C32.985 245.934 35.2322 265.81 49.5505 273.546C49.5505 273.546 57.6709 276.233 61.5109 271.181C61.5109 271.181 69.4398 264.879 62.3983 247.593C62.3983 247.593 58.2133 235.527 51.248 233.036C44.2828 230.545 49.4861 232.937 49.4861 232.937L46.79 236.691C46.79 236.691 56.3505 244.57 56.9428 253.614C56.9428 253.614 57.9708 263.393 54.3539 264.926C54.3539 264.926 46.4362 269.361 39.3758 241.47L32.985 245.934Z" fill="#879F85" />
                            <path d="M109.789 212.537C109.789 212.537 106.212 230.251 115.729 242.074C115.729 242.074 124.808 255.676 135.051 241.003C135.051 241.003 141.037 232.844 134.033 216.139L123.321 214.42C123.321 214.42 131.163 228.515 128.29 236.596C128.29 236.596 126.082 245.207 119.178 237.241C119.178 237.241 110.758 221.698 117.717 212.644L109.789 212.537Z" fill="#879F85" />
                            <path d="M77.3153 221.922C77.3153 221.922 73.7356 230.573 81.8641 243.107C81.8641 243.107 88.2545 251.235 91.7582 248.507C91.7582 248.507 96.7954 245.163 91.1608 233.4C91.1608 233.4 85.4251 221.328 81.9923 218.127L91.4515 216.259C91.4515 216.259 100.18 232.811 100.543 238.962C100.543 238.962 104.335 249.809 92.7758 256.745C92.7758 256.745 81.7394 260.232 71.1322 241.198C71.1322 241.198 65.2006 228.947 66.8176 224.081L77.3153 221.922Z" fill="#879F85" />
                        </g>
                    </svg>
                </div>

                <div className="c br8 p40 mt20 ta-center">

                    {
                        loading == true
                            ?

                            <div className='flex jc-center mt50 mb50'>
                                <div className="lds-dual-ring col"></div>
                            </div>

                            :

                            <>
                                {

                                    annonce.stt == 0

                                        ?

                                        <h1 className='cl2 mb20'>Je masque l'annonce</h1>

                                        :

                                        <h1 className='cl2 mb20'>Je démasque l'annonce</h1>

                                }

                                {(error !== '') && <p className="error">{error}</p>}
                                {(success !== '') && <p className="succes">{success}</p>}

                                {

                                    success == ''

                                        ?

                                        <>
                                            <p className='mb20'>Voulez-vous vraiment effectuer cette action ?</p>

                                            <span className='btn bg4 cl1 mr10' onClick={e => action(annonce.idA)}>Oui</span>
                                            <Link className='btn bg4 cl1' to={'/annonce/' + annonce.idA}>Non</Link>
                                        </>

                                        :

                                        <Link className='btn bg4 cl1' to={'/annonce/' + annonce.idA}>Retour fiche produit</Link>

                                }

                            </>

                    }

                </div>

            </div>

            <Footer />

        </div>
    )

}

export default MasquerAnnonce